import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
export function PricingSection() {
  return <section className="w-full py-24 bg-[#F9F9F9] px-4" data-id="element-125">
      <div className="max-w-4xl mx-auto flex flex-col items-center" data-id="element-126">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="w-full bg-white rounded-3xl shadow-2xl border-4 border-turquoise p-8 md:p-12 flex flex-col items-center relative overflow-hidden" data-id="element-127">
          {/* Decorative background elements */}
          <div className="absolute top-0 right-0 w-64 h-64 bg-turquoise/5 rounded-full blur-[50px] -translate-y-1/2 translate-x-1/2 pointer-events-none" data-id="element-128" />
          <div className="absolute bottom-0 left-0 w-64 h-64 bg-coralOrange/5 rounded-full blur-[50px] translate-y-1/2 -translate-x-1/2 pointer-events-none" data-id="element-129" />

          <h2 className="text-3xl md:text-5xl font-bold text-[#1A1A1A] mb-8 text-center relative z-10" data-id="element-130">
            Accedé hoy al MegaPack Completo
          </h2>

          <div className="bg-coralOrange text-white font-bold text-lg md:text-xl px-6 py-2 rounded-full mb-10 shadow-md relative z-10 flex items-center gap-2" data-id="element-131">
            <span data-id="element-132">⏰</span> Oferta por Tiempo Limitado
          </div>

          <div className="flex flex-col items-center mb-10 relative z-10" data-id="element-133">
            <div className="flex items-center gap-4 mb-2" data-id="element-134">
              <span className="text-2xl md:text-3xl text-gray-400 line-through font-medium" data-id="element-135">
                $39.999
              </span>
              <span className="bg-turquoise text-white font-bold text-xl md:text-2xl px-4 py-1 rounded-lg" data-id="element-136">
                50% OFF
              </span>
            </div>
            <span className="text-6xl md:text-8xl font-bold text-[#1A1A1A] tracking-tight" data-id="element-137">
              $19.999
            </span>
            <p className="text-gray-600 mt-4 text-lg font-medium" data-id="element-138">
              Pago único. Acceso inmediato. Sin suscripción.
            </p>
          </div>

          <div className="w-full max-w-2xl bg-gray-50 rounded-2xl p-6 md:p-8 mb-10 relative z-10 border border-gray-100" data-id="element-139">
            <ul className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-140">
              {['5 Tomos Completos', 'Técnicas de Estudio Probadas', 'Planillas y Templates Imprimibles', 'Estrategias para Exámenes', '3 Bonos Especiales'].map((feature, index) => <li key={index} className="flex items-center gap-3" data-id="element-141">
                  <CheckCircle2Icon className="w-6 h-6 text-turquoise shrink-0" data-id="element-142" />
                  <span className="text-gray-800 font-medium" data-id="element-143">{feature}</span>
                </li>)}
            </ul>
          </div>

          <motion.a href="https://checkout.infinita-mente.online/checkouts/cn/hWN9hJcYAJ6aX5aJ3wBC1CQj/es-ar?_r=AQAB8bH0zu89K7bsPll58nLRDWhvvq0TO43BcpK3J-clHp8&preview_theme_id=138558668898" target="_blank" rel="noopener noreferrer" whileHover={{
          scale: 1.05,
          boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.2), 0 10px 10px -5px rgba(0, 0, 0, 0.04)'
        }} whileTap={{
          scale: 0.98
        }} className="bg-goldenYellow text-deepBlue font-bold text-2xl md:text-3xl px-12 py-6 rounded-full shadow-xl transition-all duration-300 w-full md:w-auto relative z-10 mb-6 inline-block text-center no-underline" data-id="element-144">
            ¡Quiero esta oferta! →
          </motion.a>

          <div className="flex flex-col items-center gap-4 relative z-10" data-id="element-145">
            <p className="text-gray-500 flex items-center gap-2 font-medium" data-id="element-146">
              <ShieldCheckIcon className="w-5 h-5" data-id="element-147" /> Pago seguro con Mercado
              Pago
            </p>
            <div className="flex gap-6 text-sm font-bold text-gray-700" data-id="element-148">
              <span className="flex items-center gap-1" data-id="element-149">
                <ShieldCheckIcon className="w-4 h-4 text-turquoise" data-id="element-150" /> Garantía
                de 7 días
              </span>
              <span className="flex items-center gap-1" data-id="element-151">
                <ZapIcon className="w-4 h-4 text-coralOrange" data-id="element-152" /> Acceso
                inmediato
              </span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}